// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Card container ===== */
.RoutesNestedTable_card__0Jvb9 {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

/* ===== Header ===== */
.RoutesNestedTable_header__CjVk3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #f3f4f6;
  background: #fafafb;
}
.RoutesNestedTable_title__q8uph {
  font-weight: 800;
  font-size: 14px;
  color: #111827;
}
.RoutesNestedTable_controls__pA0xv {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.RoutesNestedTable_switch__XjVY5 {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 12px;
  color: #374151;
}
.RoutesNestedTable_smallBtn__VvT0v {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
}
.RoutesNestedTable_smallBtn__VvT0v:hover { background: #f9fafb; }
.RoutesNestedTable_dim__-mkwV { color: #6b7280; }

/* ===== Groups list ===== */
.RoutesNestedTable_list__HcztJ {
  position: relative;
  display: grid;
  gap: 10px;
  padding: 8px 12px 12px;
}

/* ===== Single route group ===== */
.RoutesNestedTable_group__sj1Di {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

/* Group header with meta + progress */
.RoutesNestedTable_groupHeader__Me9WH {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
}

.RoutesNestedTable_toggle__3PO1e {
  width: 28px;
  height: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  line-height: 1;
}
.RoutesNestedTable_toggle__3PO1e:hover { background: #f9fafb; }

.RoutesNestedTable_routeMeta__mBkRi { min-width: 0; }
.RoutesNestedTable_routeLine1__KTXrR {
  display: flex;
  gap: 10px;
  align-items: baseline;
}
.RoutesNestedTable_routeNo__BD53N { font-weight: 800; }
.RoutesNestedTable_window__ticJP { font-size: 12px; color: #6b7280; }

.RoutesNestedTable_routeLine2__g8\\+U5 {
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.RoutesNestedTable_link__Ph\\+gW {
  border: 0;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  padding: 0;
}
.RoutesNestedTable_link__Ph\\+gW:hover { text-decoration: underline; }

/* Progress mini bar */
.RoutesNestedTable_progress__\\+M8YH { min-width: 220px; }
.RoutesNestedTable_progressBar__Gip82 {
  height: 8px;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
}
.RoutesNestedTable_pbDelivered__SjnjT   { background: #16a34a; }
.RoutesNestedTable_pbOpened__Frjqx      { background: #2563eb; }
.RoutesNestedTable_pbUndelivered__29YEe { background: #ef4444; }
.RoutesNestedTable_progressLegend__4pr6\\+ {
  display: flex;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

/* ===== Per-route axis host (own scale) ===== */
/* у каждой группы свой хост; смещаем тики на ширину колонки подписи */
.RoutesNestedTable_axisHost__gsnXi {
  --inset: 16px;
  --label-col: 0px;           /* переопределяем инлайном, если раскрыт */
  position: relative;
  background: #fff;
  padding: 0 var(--inset);
  -webkit-user-select: none;
          user-select: none;
  
}
.RoutesNestedTable_axisHost__gsnXi.RoutesNestedTable_dragging__t5xF7 { cursor: grabbing; }

 .RoutesNestedTable_ticksRowLocal__RzQTl {
   position: sticky;
   top: 0;
   z-index: 1;
   height: 28px;
   border-bottom: 1px solid #f3f4f6;
   background: #fff;
   /* ключ: ширина = ширина оси, а не всего контейнера */
   width: calc(100% - var(--label-col));
   margin-left: var(--label-col);
   box-sizing: border-box;
 }
.RoutesNestedTable_tickLocal__yroPv {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
}
.RoutesNestedTable_tickLabel__oKz-6 {
  font-size: 11px;
  color: #6b7280;
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.RoutesNestedTable_vlineLocal__A7Cwy {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: calc(100% - 18px);
  background: #eef2f7;
}

/* свернутый слой — точки поверх оси */
.RoutesNestedTable_timelineCollapsedInner__KwESD {
  position: relative;
  height: 54px;
  padding-left: var(--label-col); /* при свёрнутом = 0px, при раскрытом = ширина подписи */
}
.RoutesNestedTable_dot__eX\\+th {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(0,0,0,.15);
}

/* развёрнутый: сетка с колонкой подписи */
.RoutesNestedTable_timelineExpanded__\\+G4a5 { position: relative; padding: 6px 0 8px; }
.RoutesNestedTable_recRow__cfVMt {
  position: relative;
  display: grid;
  grid-template-columns: var(--label-col) 1fr; /* синхронизировано с тиками */
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-top: 1px dashed #f3f4f6;
}
.RoutesNestedTable_recLabel__2Z5\\+g {
  padding: 0 10px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  color: #111827;
}
.RoutesNestedTable_recBarWrap__uYlaz { position: relative; height: 16px; }

.RoutesNestedTable_bar__G75u3 {
  position: absolute;
  top: 50%;
  height: 6px;
  transform: translateY(-50%);
  background: #0ea5e9; /* переопределяем инлайном по статусу */
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
}
.RoutesNestedTable_dotLarge__5kdlk {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(0,0,0,.15);
}

/* ===== Empty ===== */
.RoutesNestedTable_empty__LmL9J {
  color: #9ca3af;
  font-size: 13px;
  text-align: center;
  padding: 14px 0;
}

.RoutesNestedTable_groupRow__VMf2v {
  display: grid;
  grid-template-columns: 260px 1fr;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.RoutesNestedTable_routeSidebar__xj2DO {
  background: #f9fafb;
  border-right: 1px solid #e5e7eb;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.RoutesNestedTable_routeNoBtn__arnBz {
  background: transparent;
  border: none;
  font-weight: 800;
  font-size: 15px;
  cursor: pointer;
  color: #111827;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.RoutesNestedTable_routeNoBtn__arnBz:hover {
  color: #2563eb;
}



/* ===== Responsive ===== */
@media (max-width: 720px) {
  .RoutesNestedTable_groupHeader__Me9WH { grid-template-columns: auto 1fr; }
  .RoutesNestedTable_progress__\\+M8YH { grid-column: 1 / -1; }
  .RoutesNestedTable_recRow__cfVMt { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/RouteProgressDetails/components/RoutesNestedTable/RoutesNestedTable.module.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,2CAAkB,mBAAmB,EAAE;AACvC,gCAAO,cAAc,EAAE;;AAEvB,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,yCAAgB,mBAAmB,EAAE;;AAErC,sCAAa,YAAY,EAAE;AAC3B;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;AACA,oCAAW,gBAAgB,EAAE;AAC7B,mCAAU,eAAe,EAAE,cAAc,EAAE;;AAE3C;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA,wCAAc,0BAA0B,EAAE;;AAE1C,sBAAsB;AACtB,sCAAY,gBAAgB,EAAE;AAC9B;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA,0CAAiB,mBAAmB,EAAE;AACtC,0CAAiB,mBAAmB,EAAE;AACtC,0CAAiB,mBAAmB,EAAE;AACtC;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,gDAAgD;AAChD,sEAAsE;AACtE;EACE,aAAa;EACb,gBAAgB,YAAY,0CAA0C;EACtE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;;AAEnB;AACA,uEAAqB,gBAAgB,EAAE;;CAEtC;GACE,gBAAgB;GAChB,MAAM;GACN,UAAU;GACV,YAAY;GACZ,gCAAgC;GAChC,gBAAgB;GAChB,qDAAqD;GACrD,oCAAoC;GACpC,6BAA6B;GAC7B,sBAAsB;CACxB;AACD;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B,EAAE,wDAAwD;AAC1F;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C,8CAAoB,kBAAkB,EAAE,kBAAkB,EAAE;AAC5D;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C,EAAE,8BAA8B;EAC3E,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA,uCAAc,kBAAkB,EAAE,YAAY,EAAE;;AAEhD;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mBAAmB,EAAE,uCAAuC;EAC5D,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;;;AAIA,2BAA2B;AAC3B;EACE,wCAAe,+BAA+B,EAAE;EAChD,sCAAY,mBAAmB,EAAE;EACjC,mCAAU,0BAA0B,EAAE;AACxC","sourcesContent":["/* ===== Card container ===== */\r\n.card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n/* ===== Header ===== */\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fafafb;\r\n}\r\n.title {\r\n  font-weight: 800;\r\n  font-size: 14px;\r\n  color: #111827;\r\n}\r\n.controls {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n.switch {\r\n  display: inline-flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  color: #374151;\r\n}\r\n.smallBtn {\r\n  padding: 6px 10px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n}\r\n.smallBtn:hover { background: #f9fafb; }\r\n.dim { color: #6b7280; }\r\n\r\n/* ===== Groups list ===== */\r\n.list {\r\n  position: relative;\r\n  display: grid;\r\n  gap: 10px;\r\n  padding: 8px 12px 12px;\r\n}\r\n\r\n/* ===== Single route group ===== */\r\n.group {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n/* Group header with meta + progress */\r\n.groupHeader {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fff;\r\n}\r\n\r\n.toggle {\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n}\r\n.toggle:hover { background: #f9fafb; }\r\n\r\n.routeMeta { min-width: 0; }\r\n.routeLine1 {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: baseline;\r\n}\r\n.routeNo { font-weight: 800; }\r\n.window { font-size: 12px; color: #6b7280; }\r\n\r\n.routeLine2 {\r\n  font-size: 13px;\r\n  color: #374151;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.link {\r\n  border: 0;\r\n  background: transparent;\r\n  color: #2563eb;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n.link:hover { text-decoration: underline; }\r\n\r\n/* Progress mini bar */\r\n.progress { min-width: 220px; }\r\n.progressBar {\r\n  height: 8px;\r\n  background: #f3f4f6;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  display: flex;\r\n}\r\n.pbDelivered   { background: #16a34a; }\r\n.pbOpened      { background: #2563eb; }\r\n.pbUndelivered { background: #ef4444; }\r\n.progressLegend {\r\n  display: flex;\r\n  gap: 8px;\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ===== Per-route axis host (own scale) ===== */\r\n/* у каждой группы свой хост; смещаем тики на ширину колонки подписи */\r\n.axisHost {\r\n  --inset: 16px;\r\n  --label-col: 0px;           /* переопределяем инлайном, если раскрыт */\r\n  position: relative;\r\n  background: #fff;\r\n  padding: 0 var(--inset);\r\n  user-select: none;\r\n  \r\n}\r\n.axisHost.dragging { cursor: grabbing; }\r\n\r\n .ticksRowLocal {\r\n   position: sticky;\r\n   top: 0;\r\n   z-index: 1;\r\n   height: 28px;\r\n   border-bottom: 1px solid #f3f4f6;\r\n   background: #fff;\r\n   /* ключ: ширина = ширина оси, а не всего контейнера */\r\n   width: calc(100% - var(--label-col));\r\n   margin-left: var(--label-col);\r\n   box-sizing: border-box;\r\n }\r\n.tickLocal {\r\n  position: absolute;\r\n  top: 0;\r\n  transform: translateX(-50%);\r\n}\r\n.tickLabel {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n}\r\n.vlineLocal {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 1px;\r\n  height: calc(100% - 18px);\r\n  background: #eef2f7;\r\n}\r\n\r\n/* свернутый слой — точки поверх оси */\r\n.timelineCollapsedInner {\r\n  position: relative;\r\n  height: 54px;\r\n  padding-left: var(--label-col); /* при свёрнутом = 0px, при раскрытом = ширина подписи */\r\n}\r\n.dot {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,.15);\r\n}\r\n\r\n/* развёрнутый: сетка с колонкой подписи */\r\n.timelineExpanded { position: relative; padding: 6px 0 8px; }\r\n.recRow {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: var(--label-col) 1fr; /* синхронизировано с тиками */\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 0;\r\n  border-top: 1px dashed #f3f4f6;\r\n}\r\n.recLabel {\r\n  padding: 0 10px;\r\n  min-width: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 13px;\r\n  color: #111827;\r\n}\r\n.recBarWrap { position: relative; height: 16px; }\r\n\r\n.bar {\r\n  position: absolute;\r\n  top: 50%;\r\n  height: 6px;\r\n  transform: translateY(-50%);\r\n  background: #0ea5e9; /* переопределяем инлайном по статусу */\r\n  border-radius: 999px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,.08);\r\n}\r\n.dotLarge {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,.15);\r\n}\r\n\r\n/* ===== Empty ===== */\r\n.empty {\r\n  color: #9ca3af;\r\n  font-size: 13px;\r\n  text-align: center;\r\n  padding: 14px 0;\r\n}\r\n\r\n.groupRow {\r\n  display: grid;\r\n  grid-template-columns: 260px 1fr;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  overflow: hidden;\r\n}\r\n\r\n.routeSidebar {\r\n  background: #f9fafb;\r\n  border-right: 1px solid #e5e7eb;\r\n  padding: 8px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n.routeNoBtn {\r\n  background: transparent;\r\n  border: none;\r\n  font-weight: 800;\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n  color: #111827;\r\n  padding: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.routeNoBtn:hover {\r\n  color: #2563eb;\r\n}\r\n\r\n\r\n\r\n/* ===== Responsive ===== */\r\n@media (max-width: 720px) {\r\n  .groupHeader { grid-template-columns: auto 1fr; }\r\n  .progress { grid-column: 1 / -1; }\r\n  .recRow { grid-template-columns: 1fr; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `RoutesNestedTable_card__0Jvb9`,
	"header": `RoutesNestedTable_header__CjVk3`,
	"title": `RoutesNestedTable_title__q8uph`,
	"controls": `RoutesNestedTable_controls__pA0xv`,
	"switch": `RoutesNestedTable_switch__XjVY5`,
	"smallBtn": `RoutesNestedTable_smallBtn__VvT0v`,
	"dim": `RoutesNestedTable_dim__-mkwV`,
	"list": `RoutesNestedTable_list__HcztJ`,
	"group": `RoutesNestedTable_group__sj1Di`,
	"groupHeader": `RoutesNestedTable_groupHeader__Me9WH`,
	"toggle": `RoutesNestedTable_toggle__3PO1e`,
	"routeMeta": `RoutesNestedTable_routeMeta__mBkRi`,
	"routeLine1": `RoutesNestedTable_routeLine1__KTXrR`,
	"routeNo": `RoutesNestedTable_routeNo__BD53N`,
	"window": `RoutesNestedTable_window__ticJP`,
	"routeLine2": `RoutesNestedTable_routeLine2__g8+U5`,
	"link": `RoutesNestedTable_link__Ph+gW`,
	"progress": `RoutesNestedTable_progress__+M8YH`,
	"progressBar": `RoutesNestedTable_progressBar__Gip82`,
	"pbDelivered": `RoutesNestedTable_pbDelivered__SjnjT`,
	"pbOpened": `RoutesNestedTable_pbOpened__Frjqx`,
	"pbUndelivered": `RoutesNestedTable_pbUndelivered__29YEe`,
	"progressLegend": `RoutesNestedTable_progressLegend__4pr6+`,
	"axisHost": `RoutesNestedTable_axisHost__gsnXi`,
	"dragging": `RoutesNestedTable_dragging__t5xF7`,
	"ticksRowLocal": `RoutesNestedTable_ticksRowLocal__RzQTl`,
	"tickLocal": `RoutesNestedTable_tickLocal__yroPv`,
	"tickLabel": `RoutesNestedTable_tickLabel__oKz-6`,
	"vlineLocal": `RoutesNestedTable_vlineLocal__A7Cwy`,
	"timelineCollapsedInner": `RoutesNestedTable_timelineCollapsedInner__KwESD`,
	"dot": `RoutesNestedTable_dot__eX+th`,
	"timelineExpanded": `RoutesNestedTable_timelineExpanded__+G4a5`,
	"recRow": `RoutesNestedTable_recRow__cfVMt`,
	"recLabel": `RoutesNestedTable_recLabel__2Z5+g`,
	"recBarWrap": `RoutesNestedTable_recBarWrap__uYlaz`,
	"bar": `RoutesNestedTable_bar__G75u3`,
	"dotLarge": `RoutesNestedTable_dotLarge__5kdlk`,
	"empty": `RoutesNestedTable_empty__LmL9J`,
	"groupRow": `RoutesNestedTable_groupRow__VMf2v`,
	"routeSidebar": `RoutesNestedTable_routeSidebar__xj2DO`,
	"routeNoBtn": `RoutesNestedTable_routeNoBtn__arnBz`
};
export default ___CSS_LOADER_EXPORT___;
